<template>
  <fragment>
    <div class="flex flex-wrap mb-6 text-center">
      <fragment v-if="applications && applications.length > 0">
        <div
          v-for="(app, index) in applications"
          :key="index"
          class="md:w-1/2 lg:w-1/3 w-full my-4"
        >
          <application :application="app" :type="type"></application>
        </div>
      </fragment>
      <fragment
        v-if="
          applications &&
            ((applications.length > 0 && applications[applications.length - 1] &&
              ['3', '4'].includes(
                applications[applications.length - 1].status
              )))
        "
      >
        <div class="md:w-1/2 lg:w-1/3 w-full my-4">
          <application :type="type"></application>
        </div>
      </fragment>
      <div
        class="w-full"
        v-if="!applications.length"
      >
        <div class="md:w-1/2 lg:w-1/3 w-full my-4">
          <application :type="type"></application>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Application from "./Application";
import { mapGetters } from "vuex";
import { FETCH_SESSIONLESS_APP_BY_APP_TYPE } from "@/store/actions.type";
export default {
  name: "sessionless-grid",
  components: {
    application: Application,
    fragment: Fragment
  },
  props: {
    type: {
      required: true,
      type: String,
      default: ""
    }
  },
  data() {
    return {
      applications: [],
      loading: true
    };
  },
  mounted() {
    this.isCreated = true;
    this.$store
      .dispatch(FETCH_SESSIONLESS_APP_BY_APP_TYPE, this.type)
      .then(data => {
        this.applications = data.data.data.applications;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {},
  computed: {
    ...mapGetters(["currentUser"])
  }
};
</script>

<style></style>
